/* Copyright (c) 2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export type UserActivationType = 'sticky' | 'transient' | 'none';

export enum UserActivationGuardType {
    Link,
    Share,
    Input,
    PlayMedia
}
/**
 * Configuration for patching an API method.
 * @property {any} object - The object that contains the method (e.g., Element.prototype).
 * @property {string} methodName - The name of the method to patch (e.g., 'requestFullscreen').
 */
export interface ApiPatchConfig {
    object: any;
    methodName: string;
    type: UserActivationGuardType;
    returnsPromise?: boolean;
}

export interface UserActivationMessageOption {
    useInnerText?: boolean;
    text?: string;
    interpolationKey: string;
}
